export default {
  downloadDocuments: [],
  uploadDocuments: [],
  disabledButton: true
}
